import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_929'),
        action: obj => {
          this.createDialog('TenantAuthenticateDialog', {
            data: [obj],
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
        meta: (obj) => ({
          validate: obj.certified_status === 'certificating',
        }),
      },
      {
        label: i18n.t('scope.text_575'),
        actions: obj => {
          return [
            {
              label: i18n.t('scope.text_930'),
              action: obj => {
                this.createDialog('AssociateSubAccountDialog', {
                  data: [obj],
                  onManager: this.onManager,
                  refresh: this.refresh,
                })
              },
            },
            {
              label: i18n.t('scope.text_923'),
              action: obj => {
                this.createDialog('SetCustomerLevelDialog', {
                  data: [obj],
                  onManager: this.onManager,
                  refresh: this.refresh,
                  action: i18n.t('scope.text_931'),
                })
              },
            },
            {
              label: i18n.t('common_488'),
              action: obj => {
                this.createDialog('UpdateCloudAccountSettingDialog', {
                  data: [obj],
                  onManager: this.onManager,
                  refresh: this.refresh,
                })
              },
            },
            {
              label: i18n.t('op_6'),
              action: obj => {
                this.createDialog('AllowCloudSuppliersDialog', {
                  data: [obj],
                  title: i18n.t('op_6'),
                  onManager: this.onManager,
                  refresh: this.refresh,
                })
              },
            },
          ]
        },
      },
    ]
  },
}
